// Conversion bulles <-> texte éditable (1 bulle par ligne).
// La narration est préfixée "Narration: " ; les autres lignes sont des dialogues.

export function bubblesToText(bubbles) {
  return (bubbles || [])
    .map((b) =>
      (b.speaker || "").toLowerCase() === "narration"
        ? `Narration: ${b.text}`
        : b.text,
    )
    .join("\n");
}

export function parseBubbleText(text) {
  return (text || "")
    .split("\n")
    .map((l) => l.trim())
    .filter(Boolean)
    .map((line) => {
      const m = line.match(/^narration\s*:\s*(.*)$/i);
      if (m) return { speaker: "narration", text: m[1].trim() };
      return { speaker: "", text: line };
    });
}
